import React, { useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { receivePathologistsSlidesByCaseId, fetchInboxData } from '../../actions'
import { RootState } from '../../reducers'
import { SlideHandlingBase } from './SlideHandlingBase'

export function PathologistsReceiveSlides({ userId }) {
  const dispatch = useDispatch()

  const { data } = useSelector((state: RootState) => state.inboxData)
  const { role } = useSelector((state: RootState) => state.userLogin)
  const filterData = useSelector((state: RootState) => state.filterPayloadResponse)
  const { re_slide_success, re_slide_error } = useSelector(
    (state: RootState) => state.getReadyForPickupDataReducerPathologists,
  )
  const message = useSelector((state: RootState) => state.errorMessage)

  const updateDataTable = useCallback(async () => {
    await dispatch(fetchInboxData(filterData))
  }, [dispatch, filterData])

  const handleSubmit = useCallback(
    async (val, scannerMode) => {
      const filterUserResults = data.find((value) => value.case_number === val)

      if (filterUserResults?.id || role === 'NL_Pathologist') {
        await dispatch(receivePathologistsSlidesByCaseId({ id: userId, payload: val }))

        if (scannerMode) {
          // For scanner mode, show success message and delay update
          setTimeout(() => {
            updateDataTable()
          }, 1500)
        } else if (re_slide_success !== false && re_slide_error !== true) {
          updateDataTable()
        }
      }
    },
    [dispatch, userId, data, role, re_slide_success, re_slide_error, updateDataTable],
  )

  const successMessage = useCallback((caseId) => {
    return `Successfully received slides for Case #${caseId}: If you have more cases to scan, you can scan now, otherwise click Close`
  }, [])

  return (
    <SlideHandlingBase
      userId={userId}
      title="Receive Slides"
      buttonText="Receive Slides"
      dialogTitle="Receive Slides"
      dialogPrompt="Scan Barcode now, or enter the TRF ID of the case for which you recieved the slides:"
      buttonIcon="save_alt"
      inputLabel="Barcode TRF ID (5 characters only)"
      maxCaseIdLength={5}
      onSubmit={handleSubmit}
      successMessage={successMessage}
      errorMessage={message}
      isSuccess={re_slide_success}
      isError={re_slide_error}
      buttonClassName="receiveSlidesButton"
    />
  )
}
